/** ESCHER FALLS — 繁體中文。台灣・香港向け。 */

import type { Strings } from './ja';

export const ZH_HANT: Strings = {
  pour: '放水',
  lever: '拉桿',
  leverAria: '拉動拉桿',
  retry: '重新開始',
  again: '再來一次',
  next: '下一關',
  share: '分享這一張',
  shareFailed: '無法分享',
  rotateLeft: '視角向左旋轉',
  rotateRight: '視角向右旋轉',
  tiltUp: '抬高視角',
  tiltDown: '降低視角',
  topDown: '俯視',
  water: (left, total) => `水量 ${left} / ${total}`,
  moves: (left, total) => `步數 ${left} / ${total}`,
  timeLeft: (time) => `剩餘 ${time}`,
  drops: (n) => `水滴 ${n}`,

  resultClear: '通了',
  resultFail: '沒通',
  clearTitle: '通水',
  fail: {
    time: '時間用盡了',
    moves: '步數用盡了',
    drywell: '水流進了枯井',
    water: '水用盡了',
    deadend: '水落進了死路',
  },
  extendByAd: '看廣告延長 30 秒',
  extendByDrops: (cost) => `用 ${cost} 水滴延長 30 秒`,
  multiplyByAd: (mult) => `看廣告獲得 ×${mult} 水滴`,

  stages: '關卡',
  settingsAria: '設定',
  menuAria: '選單',
  back: '返回',
  loop1: '第一周',
  loop2: '第二周',
  loopNote: '第二周的步數與時間更緊。紀錄與第一周分開保存。',
  shop: '商店',
  groupMain: '正篇',
  groupExtra1: '額外關',
  groupExtra2: '額外關 其二',
  freeTrial: '試玩',
  notPurchased: (n, name) => `${n} ${name}（未購買）`,
  lockedStage: '未解鎖的關卡',
  extraLockedFree: '第一關《逆流之瀑》可免費玩。其餘在設定（≡）中購買後開啟。',
  extraLocked: '在設定（≡）中購買後開啟。',
  extra2Locked: '第11關起，通過第1–10關後開啟。',
  extra2LockedUnowned: '在設定（≡）中購買，並通過第1–10關後，第11關起開啟。',
  extra2Note: '通過全部額外關後開啟。',
  progress: (cleared, total) => `正篇 ${cleared} / ${total} 通水`,
  totalTime: (time) => `合計 ${time}`,
  totalNone: '合計 —',

  settings: '設定',
  bgm: '環境音',
  se: '音效',
  testSound: '試聽',
  audioStatus: (state) => `聲音狀態：${state}`,
  audioState: {
    locked: '未解鎖（觸碰螢幕一次即可啟動）',
    running: '正在播放',
    suspended: '已暫停',
  },
  demoNote: (n) => `網頁試玩版可玩前 ${n} 關。全部 42 關在應用程式裡。`,
  demoGet: '到 App Store 取得',
  // — 今日の一面（日替わり）
  dailyTitle: '今日一關',
  dailyLoading: '載入中…',
  dailyOffline: '無法連線，今日一關暫時打不開',
  dailyPlay: '開始',
  dailyCleared: (time: string) => `已通過 ${time}`,
  archiveTitle: '往日關卡',
  upcomingTitle: '後續關卡',
  archiveLocked: '最近3天免費。購買額外關後，更早的關卡全部開放',
  language: '語言',
  languageAuto: '跟隨裝置',
  palette: '配色',
  worn: '使用中',
  owned: '已擁有',
  buyDrops: '購買水滴',
  restore: '恢復購買',
  writeReview: '為這個應用程式評分',
  moreApps: '開發者的其他作品',
  restoreChecking: '正在確認…',
  restoreDone: (n) => `已恢復 ${n} 項`,
  restoreNone: '沒有可恢復的項目',
  restoreFailed: '無法恢復',
  chooseStage: '選擇關卡',
  resume: '繼續',

  prizeLabel: '通關獎勵',
  awardLabel: '稱號',
  toExtra: '前往額外關',
  toLoop2: '前往第二周',
  toStart: '回到起點',
  allClearTitle: '走遍',
  allClearBody: (n) => `${n} 條水路全部通了水`,
  multiplyTimes: (mult) => `看廣告獲得 ${mult} 倍`,
  noteRank: '稱號會留在紀錄裡，顯示在關卡列表的上方。',
  noteLoop2: '第二周已開啟。步數與時間更緊。',
  notePartOne: '至此是第一部。水，還沒有往上流。',
  inviteTry: '試玩額外關 一',
  inviteOpen: '開啟額外關 其一 20 關',
  dateLine: (d) => `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`,

  completionTitle: '渡越無窮者',
  rank: {
    none: '—',
    sovereign: '御水者',
    architect: '瀑布的設計者',
    mason: '石匠',
    apprentice: '學徒',
    wayfarer: '旅人',
  },

  skin: {
    hakushi: '白紙',
    ai: '藍',
    koke: '苔',
    shu: '朱',
    sumi: '墨',
  },

  product: {
    drops600: '水滴 600',
    drops1600: '水滴 1,600',
    drops5000: '水滴 5,000',
    noads: '移除廣告',
    extras: '額外關 其一 21 關（無廣告）',
  },
};
